export default {"src":"/_next/static/media/disable_regular.a45d4955.svg","height":24,"width":24};